<div class="beneficiary-info bg-white flex items-center justify-between flex-nowrap">
    <div class="flex items-center flex-nowrap">
        <div nz-row class="beneficiary-box justify-center">
            {{getInitials(accountName)}}
        </div>
        <div nz-row class="flex-col">
            <div class="account-name whitespace-normal">{{accountName}} </div>
            <div nz-row class="account-detail text-dark-purple">
                <div class="bank-name font-normal opacity-50 whitespace-normal">{{bankName}}</div> &nbsp;
                <div class="account-number font-semibold opacity-50 whitespace-normal">{{accountNumber}}</div>
            </div>
        </div>
    </div>
    <div *ngIf="changable">
        <a class="change-button" (click)="emitChange()">Change</a>
    </div>
</div>